export default __webpack_public_path__ + "728077ffd408b700f3d0cb8980c46ba2.png";